















import { Component, Vue } from 'vue-property-decorator';
import { decodeJWT, initializeGoogleSignIn } from '~/plugins/social/google';

@Component
export default class GoogleLoginButton extends Vue {
  isGoogleInitialized: boolean = false;

  async mounted () {
    // Initialize Google Identity Services when component mounts
    await this.initializeGoogle();
  }

  async initializeGoogle () {
    try {
      await initializeGoogleSignIn({
        client_id: this.$config.GOOGLE_APP_ID,
        callback: this.handleGoogleResponse.bind(this),
      });
      this.isGoogleInitialized = true;
    } catch (error) {
      console.error('Failed to initialize Google Identity Services:', error);
    }
  }

  /*
    This method starts the google process using the new One Tap or popup flow
  */
  async googleConnect () {
    try {
      if (!this.isGoogleInitialized) {
        await this.initializeGoogle();
      }

      // Show Google One Tap prompt
      if (window?.google?.accounts?.id) {
        window.google.accounts.id.prompt((notification: any) => {
          if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            // One Tap was not displayed or skipped, fallback to manual flow
            console.log('One Tap not available, user needs to click login');
          }
        });
      }
    } catch (e) {
      this.$emit("error", e.error ?? e);
    }
  }

  /*
    This method handles the response from Google Identity Services
    It receives a JWT credential instead of the old GoogleUser object
  */
  async handleGoogleResponse (response: Types.CredentialResponse) {
    try {
      this.$social.rememberProvider("google");

      // Decode the JWT token to get user information
      const userInfo = decodeJWT(response.credential);

      if (!userInfo) {
        throw new Error('Failed to decode Google credential');
      }

      const mockGoogleUser = {
        getAuthResponse: () => ({
          id_token: response.credential,
        }),
        getBasicProfile: () => ({
          getEmail: () => userInfo.email,
          getGivenName: () => userInfo.given_name,
          getFamilyName: () => userInfo.family_name,
          getId: () => userInfo.sub,
        }),
      };

      await this.onUserLoaded(mockGoogleUser);
    } catch (error) {
      console.error('Error handling Google response:', error);
      this.$emit("error", error);
    }
  }

  /*
    This method handles the response from google api, and allows to sign in or
    not the user
  */
  async onUserLoaded (googleUser: any) {
    // Try to connect with the API
    const signInPayload: Types.SignInSocialPayload = {
      provider: "google",
      body: {
        social_token: googleUser.getAuthResponse().id_token,
        social_user_id: "",
      },
    };
    const err = await this.$store.dispatch('user/signinWithSocial', signInPayload);
    if (!err) {
      // The API call has succeeded, which means the user was already known and
      // is now authenticated. Skip the signup entirely.
      return this.$emit("signed-in");
    }

    // Retrieve user information from google
    const googleProfile = googleUser.getBasicProfile();

    const userInfo: Types.SocialUserInfo = {
      provider: "google",
      ...signInPayload.body,
      email: googleProfile.getEmail(),
      firstname: googleProfile.getGivenName(),
      lastname: googleProfile.getFamilyName(),
    };
    return this.$emit("need-signup", userInfo);
  }
}
